import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/admin/audit',
}).lazy(() => import('./audit.lazy').then((d) => d.Route))
